const BASE_GROUPS = new Set(["会员基础权益", "个人直推"]);

function ruleKey(item) {
  return [item.group, item.name, item.formula, item.party, item.type].join("|");
}

function positiveItems(items) {
  return items.filter(item => item.amount > 0);
}

function memberLevelFrom(items, fallback) {
  const names = items.map(item => item.name).join(" ");
  if (names.includes("星级")) return "星级会员";
  if (names.includes("普通")) return "普通会员";
  return fallback;
}

function groupRoleItems(items, scope) {
  const groups = new Map();
  for (const item of items) {
    if (BASE_GROUPS.has(item.group)) continue;
    if (!groups.has(item.group)) groups.set(item.group, []);
    groups.get(item.group).push({ ...item, scope });
  }
  return [...groups.entries()].map(([group, groupItems]) => ({
    title: `${group.replace(/权益$/, "")} · ${scope === "private" ? "私域权益" : scope === "public" ? "公域权益" : "通用权益"}`,
    scope,
    items: groupItems
  }));
}

export function buildNarrativeLedger(privateResult, publicResult) {
  const privateItems = positiveItems(privateResult.breakdown);
  const publicItems = positiveItems(publicResult.breakdown);
  const publicMap = new Map(publicItems.map(item => [ruleKey(item), item]));
  const privateKeys = new Set(privateItems.map(ruleKey));
  const sharedItems = privateItems.filter(item => publicMap.has(ruleKey(item)));
  const privateOnly = privateItems.filter(item => !publicMap.has(ruleKey(item)));
  const publicOnly = publicItems.filter(item => !privateKeys.has(ruleKey(item)));
  const buyerItems = sharedItems.filter(item => item.group === "会员基础权益" && item.party === "invitee");
  const referralItems = sharedItems.filter(item => item.group === "个人直推" && item.party === "inviter");
  const sharedSections = [];

  if (buyerItems.length) {
    sharedSections.push({
      title: `被邀请人 B（${memberLevelFrom(buyerItems, "会员")}）所得`,
      items: buyerItems.map(item => ({ ...item }))
    });
  }
  if (referralItems.length) {
    sharedSections.push({
      title: `邀请人 A（${memberLevelFrom(referralItems, "会员")}）· 个人直推`,
      items: referralItems.map(item => ({ ...item }))
    });
  }

  const roleSections = [
    ...groupRoleItems(sharedItems.filter(item => !BASE_GROUPS.has(item.group)), "common"),
    ...groupRoleItems(privateOnly, "private"),
    ...groupRoleItems(publicOnly, "public")
  ];
  if (!roleSections.length) {
    return {
      sharedSections,
      roleSections,
      totals: { mode: "single", inviter: { ...privateResult.inviter }, invitee: { ...privateResult.invitee } }
    };
  }
  return {
    sharedSections,
    roleSections,
    totals: {
      mode: "byScope",
      private: { inviter: { ...privateResult.inviter }, invitee: { ...privateResult.invitee } },
      public: { inviter: { ...publicResult.inviter }, invitee: { ...publicResult.invitee } }
    }
  };
}
